import { DialogueUIOptionConfig } from "../../components/ui/YouRespondUI";
import { NurseStationComputerUIConfig } from "../../components/ui/NurseStationComputerUI";
import BaseScenarioPart from "../../cvp-webgames-core/Scenario/BaseScenarioPart";
import { Segments } from "../../cvp-webgames-core/Scenario/Segments";
import { constants } from "../../misc/constants";
import { CalmBaseScenario, ScoreType, Window508Type } from "../CalmBaseScenario";
import Scenario4 from "./Scenario4";
import { NurseStationComputerSingleQustionUIConfig } from "../../components/ui/NurseStationComputerSingleQuestionUI";

export default class Scenario4Part7 extends BaseScenarioPart<CalmBaseScenario> {

	private partIndx = 4;
	chapterIds = {
		scenario4_4A_s13: 'CALM - Scenario 4 - 4A - Segment 13',		
	}

	constructor(scenario: Scenario4, private onDone: () => void) {
		super(scenario);
		CalmBaseScenario.partIndx = this.partIndx;
	}

	public get videoUrl(): string[] {
		return ['./assets/videos/scenario4/calm-scenario4-avatar' + this.scenario.avatarIndx + '.mp4'];
	}

	public get partId(): string {
		return constants.scenarios.scenario4.parts.level4Part7.id;
	}

	public start() {
		const context = this;
		context.segment1Step1IncomingCall();
	}

	private segment1Step1IncomingCall() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.updateObjective('');
		context.segment1Step2Dialogue()
	}

	private segment1Step2Dialogue() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		this.scenario.dialog(
			'CN-C05-L3-000a',
			[{
				text: 'I’m a little busy right now. I’ll delegate this to another staff member.',
				feedback: 'While delegating the in-service to another staff member, such as a Nurse Educator, may be plausible in some cases, there is an urgent need for the in-service since the unit still has the Thai patient. Additionally, all of the nurses have heavy patient loads with a patient in isolation, plus a nurse is off the unit taking her patient to a procedure. You need to address this need as soon as possible.',
				scoreType: ScoreType.Worst,
				isCorrect: false // Rank worst
			}, {
				text: 'Okay great! I’ll get the policy so I know what to talk about.',
				scoreType: ScoreType.Best,
				isCorrect: true // Rank best
			}, {
				text: 'I’ll call a huddle right now!',
				feedback: 'You first need to prepare for the in-service before you can call a huddle on this urgent need.',
				scoreType: ScoreType.Worst,
				isCorrect: false // Rank worst
			}],
			(selectedOption: DialogueUIOptionConfig) => {
				selectedOption.hide = true; // set hide here
				context.scenario.evaluateAnswer(selectedOption, () => context.segment2Step1NurseManagerResponds(), context.partIndx);
			}
		);
		context.scenario.updateObjective('Select your response to Trista');
	}

	private segment2Step1NurseManagerResponds() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.updateObjective('');
		context.playVideoChapter(context.chapterIds.scenario4_4A_s13, () => {
			context.segment3Step2UseComputer();
		});
	}

	private segment3Step2UseComputer() {
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.updateObjective('');
		context.scenario.update508Window(Window508Type.NurseStationComputerUI);
		const instanceId = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.NurseStationComputerUI, {
			reports: null,
			review: { 
				text:
					` 
					<p class="regular-description-font" style="margin: 0">
					LIMITED ENGLISH PROFICIENCY SERVICES<br /><br >
					<span style="color: rgb(222, 225, 156)">
					1. PURPOSE. To implement a Limited English Proficiency (LEP) program for telephonic language interpretation and on-site language interpretation at the VAMC, and establish the policy and responsibilities associated with this program. <br /><br />

					2. POLICY. It is the policy of this medical center that all Veterans receive equitable and the highest quality of health care obtainable. To this end, those Veterans with limited English proficiency shall not receive lesser healthcare resulting from a failure to effectively communicate VHA health care treatment options and benefits. <br /><br />

					3. ACTIONS/PROCEDURES.</span> <br /><br />

						a. Contact Interpreter Services. <br /><br />

						b. Local staff may provide interpretation services to help explain common or daily nursing care instructions. Local staff may not provide interpretation services for official medical forms requiring patient signature. < /br>< /br>

						c. If the need for telephonic interpreter services arises at the medical center, the healthcare provider should: <br /><br />

							1. When feasible and if not already done, bring the patient to a private area with a phone that has speakerphone options, and <br /><br />

							2. Follow the instructions provided in Attachment A.
					</p>
					`
			},
			reflects: null,
			onClosed: (config: NurseStationComputerUIConfig) => {
				context.scenario.update508Window(Window508Type.Main);
				context.scenario.gameManager.UiManager.destroyUIInstanceById(instanceId);
				context.segment3Step3Quiz1();
			}
		})
	}
 
	private segment3Step3Quiz1(){
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.updateObjective('');
		context.scenario.update508Window(Window508Type.NurseStationComputerSingleQuestionUI);
		context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.NurseStationComputerSingleQuestionUI, {
			title: 'What’s an appropriate length of time for this ad hoc in-service?',
			refresh: true,
			options: [
				{
					text: '10 - 15 minutes',
					isCorrect: true,
					scoreType: ScoreType.Best,
					feedback: 'Based on the key points for this in-service, 10-15 minutes does seem appropriate.'
				},
				{
					text: '1 hour',
					isCorrect: false,
					scoreType: ScoreType.Zero,
					feedback: 'This seems lengthy unless you plan to have hands-on instruction.'
				},
				{
					text: '1 day',
					isCorrect: false,
					scoreType: ScoreType.Zero,
					feedback: 'One day is too much time spent on this topic when staff are already pressed for time.'
				}
			],
			onChoiceSelected: (selectedOption: DialogueUIOptionConfig) => {
				context.scenario.evaluateAnswer(selectedOption, () => {}, context.partIndx) 
			},
			onClosed: (config: NurseStationComputerSingleQustionUIConfig) => { // <<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<
				context.scenario.destroyAllUIInstances();
				context.segment3Step3Quiz2();
			},
		})
	}
/*
	private segment3Buffer(){ // there's a bug where if there's no buffer between the 2 quizzes, the body will not update
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.playVideoChapter(context.chapterIds.scenario4_1C_s18, () => {
			context.segment3Step3Quiz2();
		});
	}
*/
	private segment3Step3Quiz2(){
		this.scenario.destroyAllUIInstances();
		var context = this;
		context.scenario.updateObjective('');
		context.scenario.update508Window(Window508Type.NurseStationComputerSingleQuestionUI);
		const instanceId = context.scenario.gameManager.UiManager.createUIInstance(constants.uiNames.NurseStationComputerSingleQuestionUI, {
			title: 'What’s an appropriate way to schedule this ad hoc in-service?',
			refresh: true,
			options: [
				{
					text: 'Offer the ad hoc in-service at start and end of a shift for several shifts',
					isCorrect: true,
					scoreType: ScoreType.Best,
					feedback: 'Yes, this approach allows multiple options to attend and has limited impact on patient care, staff, and Charge Nurse time.'
				},
				{
					text: 'Have staff find the Charge Nurse when they have a 15-minute lull in their shift to get the in-service',
					isCorrect: false,
					scoreType: ScoreType.Zero,
					feedback: 'This approach is very convenient for staff and supports patient care but providing the in-service at impromptu times would be a time burden on the Charge Nurse.'
				},
				{
					text: 'Have staff come in for the in-service at one of three designated times',
					isCorrect: false,
					scoreType: ScoreType.Zero,
					feedback: 'This approach is a burden to the staff to come in for a 15-minute in-service and can create overtime.'
				}
			],
			onChoiceSelected: (selectedOption: DialogueUIOptionConfig) => {
				context.scenario.evaluateAnswer(selectedOption, () => {}, context.partIndx) 
			},
			onClosed: (config: NurseStationComputerSingleQustionUIConfig) => {
				context.scenario.gameManager.UiManager.destroyUIInstanceById(instanceId)
				context.onDone();
			},
		})
	}
}
